import { Injectable, NgZone } from '@angular/core';
import { FileModalComponent } from '@scaffold/dialogs/file-modal/file-modal.component';
import {
  ScaffoldDialogService,
  ScaffoldDialogRef,
} from '@app/framework/dialog/scaffold-dialog.service';

@Injectable({
  providedIn: 'root',
})
export class TinyMCEOptions {
  render: boolean = true;
  dialogRef: ScaffoldDialogRef;
  options;
  height: 775;
  constructor(
    public dialog: ScaffoldDialogService,
    private _zone: NgZone
  ) {
    this.options = this.getOptions();
    var $this = this;
    this.options.file_browser_callback = function (
      field_name,
      cur,
      filter,
      win
    ): void {
      $this.openFileBrowser.call($this, field_name, cur, filter, win);
    };

    /* this.options.images_upload_handler = function (blobInfo, success, failure) {
       console.log("UPLOAD")
       $this.uploadFile.call($this, blobInfo, success, failure)

     }*/
  }

  openFileBrowser(field_name, cur, filter, win) {
    this._zone.run(() => {
      console.log(cur, filter);
      let settings: any = {
        context: {
          data: {
            target_z: 65538,
            filter: filter,
            source: 'text',
            cur: cur.replace(/\/files\//, ''),
          },
        },
      };
      this.dialogRef = this.dialog.open(FileModalComponent, settings);

      this.dialogRef.onClose.subscribe(result => {
        if (result && typeof result !== 'string') {
          win.document.getElementById(field_name).value = '/files/' + result.id;
        }
      });
    });
  }

  /*uploadFile(blobInfo, success, failure) {
    let sent = false;
    this._zone.run(() => {
      let file = new File(blobInfo.blob(), blobInfo.filename());
      if (this.courseService && this.courseService.id) {
        let progress = this.uploadService.uploadSingle(file, this.courseService.id);
          progress.subscribe(p => {
            console.log(p)
            if (p.percent === 100 && !sent) {
              sent = true
              success('/files/' + p.file)
            }
          });

      }
    })
  }*/

  getOptions() {
    var _this = this;
    return {
      inline: true,
      mode: 'exact',
      // fixed_toolbar_container: '#App', //potential add in the future
      branding: false,
      //  selector: 'editor div',
      browser_spellcheck: true,
      resize: true,
      plugins: [
        'advlist lists charmap link',
        'searchreplace wordcount visualblocks visualchars nonbreaking noneditable',
        'image autoresize textcolor table code paste, template' /* , colorpickerBeyondGrammar"*/,
      ],
      advlist_bullet_styles: 'default,circle,disc,square,none',
      paste_auto_cleanup_on_paste: true,
      max_height: 500,
      paste_retain_style_properties:
        'background background-color color font-size',
      // paste_data_images: false,
      paste_remove_styles: false,
      add_unload_trigger: false,
      allow_script_urls: true,
      remove_script_host: false,
      // minHeight: 775, /* , change height text input*/
      convert_urls: false,
      templates: [
        {
          title: 'Some title 1',
          description: 'Some desc 1',
          content: 'My content',
        },
      ],
      skin: 'lightgray',
      schema: 'html5',
      removed_menuitems: 'copy cut paste',
      toolbar:
        'undo redo | link | styleselect | bold italic | alignmenu | bindent | bullist numlist listindent listoutdent | forecolor backcolor | wrapselection | external',
      statusbar: true,
      custom_elements:
        'math,maction,maligngroup,malignmark,menclose,merror,mfenced,mfrac,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msup,msubsup,mtable,mtd,mtext,mtr,munder,munderover,semantics,annotation,annotation-xml,mathvariant,mathsize,mathcolor,mathbackground',
      valid_children: '+span[math],+p[math],+code[ol]',
      extended_valid_elements:
        '@[itemscope|itemtype|itemid|itemprop|content|artifacttype],embed[flashvars|width|height|src|class|id|type],a[onclick|href|name|target|rel|title|class|style|id|download|hreflang|media|type],' +
        'mo[*],mover[*],munderover[*],munder[*],maction[*],mtable[*],mstack[*],math[*],mfrac[*],mfenced[*],mtd[*],mtr[*],mlabeledtr[*],mscarry[*],mstyle[*],mpadded[*],mi[*],mrow[*],ms[*],mtext[*],malignmark[*],maligngroup[*],mglyph[*],mspace[*],' +
        'All[href|id|mathbackground|mathcolor|xlink|href],' +
        'msline[*],mscarries[*],mlongdiv[*],mn[*],menclose[*],msgroup[*],msrow[*],mmultiscripts[*],msub[*],' +
        'div[*],input[*],i[class|title],img[class|src|border=0|alt|title|hspace|vspace|width|height|align|onmouseover|onmouseout|name|aria-describedby|style|onclick]',
      object_resizing: true,
      content_style: "body:{background-color:#fff;height:'50vh';}",
      paste_preprocess: function (plugin, args) {
        console.log(args);
        console.log(plugin);
        var spa = new RegExp(String.fromCharCode(61623), 'g');
        args.content = args.content
          .replace(spa, '\u2022')
          .replace(/&nbsp;/g, ' ');
      },
      paste_postprocess: function (plugin, args) {
        //   console.log("running clean paste");
        var replaceWordChars = function (text) {
          var s = text;
          // smart single quotes and apostrophe
          s = s.replace(/[\u2018\u2019\u201A]/g, "'");
          // smart double quotes
          s = s.replace(/[\u201C\u201D\u201E]/g, '"');
          // ellipsis
          s = s.replace(/\u2026/g, '...');
          // dashes
          s = s.replace(/\u2013/g, '-');
          s = s.replace(/\u2014/g, '&#8212;');
          // circumflex
          s = s.replace(/\u02C6/g, '^');
          // open angle bracket
          s = s.replace(/\u2039/g, '<');
          // close angle bracket
          s = s.replace(/\u203A/g, '>');
          // spaces
          s = s.replace(/[\u02DC\u00A0]/g, ' ');
          s = s.replace(/<p>&nbsp;<\/p>/g, '');
          s = s.replace(/(&nbsp;)+/g, ' ');
          let previous;
          do {
            previous = s;
            s = s.replace(/<!--[\s\S]*?-->/g, '');
          } while (s !== previous);
          return s;
        };
        var pasted = args.node;
        pasted.innerHTML = replaceWordChars(pasted.innerHTML);
        console.log(pasted);

        while (pasted.getElementsByClassName('NormalTextRun').length > 0) {
          unwrap(pasted.getElementsByClassName('NormalTextRun')[0]);
        }
        while (pasted.getElementsByClassName('TextRun').length > 0) {
          unwrap(pasted.getElementsByClassName('TextRun')[0]);
        }

        pasted.querySelectorAll('b').forEach(function (obj) {
          let newElem = document.createElement('strong');
          newElem.textContent = obj.textContent;
          obj.parentNode.replaceChild(newElem, obj);
        });

        pasted.querySelectorAll('i').forEach(function (obj) {
          let newElem = document.createElement('em');
          newElem.textContent = obj.textContent;
          obj.parentNode.replaceChild(newElem, obj);
        });

        /*   pasted.querySelectorAll("img, object, math, audio, video").forEach(function (obj) {
             remove(obj);
           });*/

        pasted.querySelectorAll('a').forEach(function (anchor) {
          anchor.setAttribute('target', '_blank');
        });

        pasted.querySelectorAll('div').forEach(function (div) {
          removeNestedDiv(div);
        });

        pasted.childNodes.forEach(function ($this) {
          if ($this.tagName == 'P') {
            console.log($this.textContent.match(/\S/), $this.childElementCount);
            if (!$this.textContent.match(/\S/)) remove($this);
          }
        });
        let tableattrs = [
          'align',
          'bgcolor',
          'border',
          'cellpadding',
          'frame',
          'rules',
          'summary',
          'width',
        ];

        let cellattrs = [
          'align',
          'axis',
          'bgcolor',
          'char',
          'charoff',
          'height',
          'nowrap',
          'valign',
          'width',
        ];
        pasted.querySelectorAll('table').forEach(function (table) {
          tableattrs.forEach(function (attr) {
            table.removeAttribute(attr);
          });
          table.querySelectorAll('*').forEach(function (cell) {
            cellattrs.forEach(function (attr) {
              cell.removeAttribute(attr);
            });
          });
        });

        convertFakeListsToProperLists(pasted);

        function removeNestedDiv(el) {
          if (el && el.childNodes.length === 1 && el.parentNode) {
            const childNode = el.firstChild;
            const elParent = el.parentNode;
            elParent.replaceChild(childNode, el);
          }
        }

        function convertFakeListsToProperLists(node) {
          var curNode;
          getNextList();
          function getNextList() {
            var listToConvert = [];
            node.querySelectorAll('p').forEach(function (p) {
              if (checkPara(p)) {
                listToConvert.push(p);
                curNode = p;
                return false;
              }
            });
            if (listToConvert.length > 0) {
              while (
                curNode.nextSibling.tagName === 'P' &&
                checkPara(curNode.nextSibling)
              ) {
                curNode = curNode.nextSibling;
                console.log(curNode);
                listToConvert.push(curNode[0]);
              }
              converList(listToConvert);
              var listToConvert = [];
              getNextList();
            } else {
              console.log(pasted);
              while (pasted.querySelectorAll('ul + ul').length > 0) {
                var sl = pasted.querySelectorAll('ul + ul')[0];
                console.log(sl);
                console.log(sl.previousElementSibling);
                console.log(sl.previousElementSibling.innerHTM);

                sl.previousElementSibling.innerHTML =
                  sl.previousElementSibling.innerHTML + sl.innerHTML;
                remove(sl);
              }
            }
          }

          function converList(listItems) {
            var list = document.createElement(
              listItems[0].getAttribute('data-listType')
            );

            listItems.forEach(function (item, i) {
              console.log(item.innerHTML);
              list.innerHTML +=
                '<li>' +
                item.innerHTML
                  .replace(/&nbsp;/g, ' ')
                  .replace(/^\s*[\u2022\u00b7\u00a7\u00d8\u25CF]\s* /, '')
                  .replace(/^\s*\w+\.\s* /)
                  .trim() +
                '</li>';
              if (i === listItems.length - 1) {
                item.parentNode.replaceChild(list, item);
              } else {
                remove(item);
              }
              console.log(list);
            });
          }

          function checkPara(p) {
            console.log('checking', p);
            if (p) {
              var nodeText = p.innerText;
              if (/^\s*[\u2022\u00b7\u00a7\u00d8\u25CF]/.test(nodeText)) {
                console.log('found', p);
                p.setAttribute('data-listType', 'ul');
                return true;
              }

              // Detect ordered lists 1., a. or ixv.
              else if (/^\s*\w+\./.test(nodeText)) {
                // Parse OL start number
                let matches = /([0-9])\./.exec(nodeText);
                let start;
                if (matches) {
                  start = parseInt(matches[1], 10);
                }
                console.log('found', p);
                p.setAttribute('data-listType', 'ul');
                return true;
              }
            }
            return false;
          }
        }

        function unwrap(el) {
          if (!el) {
            return false;
          } else {
            var textnode = el.firstChild,
              elParent = el.parentNode;
            elParent.replaceChild(textnode, el);
          }
        }

        function remove(el) {
          el.parentNode.removeChild(el);
        }
      },
      bgOptions: {
        service: {
          //localization for BeyondGrammar interface, will be used default or got by system information, please use same version with the plugin.
          i18n: {
            en: 'https://prowriting.azureedge.net/beyondgrammar-tinymce/1.0.16/dist/i18n-en.js',
          },

          //You should signup for getting this key
          apiKey: 'E8FEF7AE-3F36-4EAF-A451-456D05E6F2A3',

          //[optional] You can specify it for permanent access to your settings and dictionaries
          //userId: "<YOUR_USER_ID>",

          //[optional] path to js file with BeyondGrammar Core
          //sourcePath : "",

          //[optional] path to service which provides grammar checking
          // url shouldn's contains / in the end
          //serviceUrl : "https://rtg.prowritingaid.com/api/v1",
        },
        grammar: {
          //[optional] Default language [en-US, en-GB],
          languageIsoCode: 'en-US',

          //[optional] checking Style. By default is "true"
          checkStyle: true,

          //[optional] checking Spelling. By default is "true"
          checkSpelling: true,

          //[optional] checking Grammar. By default is "true"
          checkGrammar: true,

          //[optional] Show thesaurus information by double click, by default true
          showThesaurusByDoubleClick: true,

          //[optional] Showing context thesaurus, works only if showThesaurusByDoubleClick = true, by default false
          showContextThesaurus: false,
        },
        /*  style_formats: [{
                  title: 'Subheading',
                  block: 'h3',
                  classes: 'subhead'
              }, {
                  title: 'Title 1',
                  block: 'h3'
              }, {
                  title: 'Title 2',
                  block: 'h4'
              }, {
                  title: 'Monospace',
                  inline: 'span',
                  classes: 'monospace'
              }, {
                  title: 'APA Citation',
                  block: 'p',
                  classes: 'reference_apa'
              }, {
                  title: 'Indent',
                  block: 'p',
                  classes: 'block-indent'
              }],
          formats: {
              alignleft: {selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table', classes: 'text-align-left'},
              aligncenter: {selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table', classes: 'text-align-center'},
              alignright: {selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table', classes: 'text-align-right'},
              alignjustify: {selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table', classes: 'text-align-justify'},
              bold: {inline: 'strong'},
              italic: {inline: 'em'},
          }*/
      },
    };
  }

  reInit() {
    console.log('reinit');
    setTimeout(() => {
      this.render = false;
      setTimeout(() => {
        this.render = true;
      }, 10);
    });
  }
}
